<template>
  <of-dialog :title="formTitle" @onCancel="cancel" :width="width">
    <div slot="content">
      <el-form ref="form" label-width="150px" :model="dataForm">
        <el-form-item label="项目名称：">
          {{ dataForm.Name }}
        </el-form-item>
        <el-form-item label="封面图：">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            :on-preview="onPicPreview"
            :file-list="pictureList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <!-- <div class="el-upload__tip" slot="tip">支持扩展名：.jpg</div> -->
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img
              style="width: 80%; height: 70%; margin-left: 10%"
              :src="dialogImageUrl"
              alt
            />
          </el-dialog>
        </el-form-item>
        <el-form-item label="项目类别：">
          {{ dataForm.Type }}
        </el-form-item>
        <el-form-item label="项目实施单位：">
          {{ dataForm.WorkUnit }}
        </el-form-item>
        <el-form-item label="负责人：">
          {{ dataForm.Leader }}
        </el-form-item>
        <el-form-item label="设立时间：">
          {{ (dataForm.EstablishTime * 1000) | formatDate2 }}
        </el-form-item>
        <el-form-item label="预算金额：">
          {{ dataForm.Budget }}
        </el-form-item>
        <el-form-item label="资金来源：">
          {{ showSource(dataForm.Source) }}
        </el-form-item>
        <el-form-item label="拨款公益项目：" v-if="dataForm.Source == 0">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="受赠者：">
          {{ showDirection(dataForm.Direction) }}
        </el-form-item>
        <el-form-item label="附件：">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            multiple
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="项目介绍：">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Describe"
            :height="500"
            :isEdit="true"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      width: "70%",
      dialogVisible: false,
      dialogImageUrl: "",
      pictureList: [], //封面图数组
      fileList: [], //附件数组
    };
  },
  mounted() {
    let that = this;
    that.getImg();
    that.getfile();
  },
  components: {
    OfDialog,
    OfTinymce,
  },
  computed: {
    showSource() {
      return (data) => {
        switch (data) {
          case 0:
            return "社会捐赠";
          case 1:
            return "财政拨款";
          case 2:
            return "其他";
        }
      };
    },
    showDirection() {
      return (data) => {
        return data == 1 ? "定向" : "非定向";
      };
    },
  },
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    getImg() {
      let that = this;
      if (that.dataForm.CoverMap || that.dataForm.CoverMap != null) {
        let params = { Id: that.dataForm.CoverMap };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //初始化附件
    getfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl =
        "/api/File/Download?Id=" + file.response.Data.FileId;
      that.dialogVisible = true;
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
.el-date-editor >>> .el-input__icon {
  display: none;
}

.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.of-dialog >>> .el-button--primary {
  display: none;
}
.of-dialog >>> .el-button--default {
  display: none;
}
</style>

